import { Badge, Box, Group, Stack, Text } from '@mantine/core';

const CampaignCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                <Group gap={'xs'}>
                    <Text>{rowData.campaign?.name || 'campaign'}</Text>
                    <Badge
                        color={'blue'}
                        size={'xs'}>
                        {rowData.type}
                    </Badge>
                </Group>
                <Text>{rowData.user?.name || 'admin'}</Text>
            </Stack>
        </Box>
    );
};

const CampaignColumn = () => ({
    accessorKey: 'campaign.name',
    header: 'Campaign',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <CampaignCell cell={cell} />,
});
export default CampaignColumn;
